<!-- requests/over_due -->
<template>
  <RequestsTableRedesigned
    :api-url-props="'/v2/requests?over_due=true'"
    title="Over Due Requests"
  />
</template>

<script>

import RequestsTableRedesigned from './RequestsTableRedesigned.vue'

export default {
  components: {
    RequestsTableRedesigned,
  },

}
</script>
